import { Radio, RadioGroup } from '@headlessui/react'
import { CheckCircleIcon } from '@heroicons/react/20/solid'
import PropTypes from 'prop-types';

const growModes = [
  { id: 1, title: 'Spawning', description: 'High humidity, high CO2' },
  { id: 2, title: 'Fruiting', description: 'High humidity, low CO2' },
  { id: 3, title: 'Custom', description: 'Set custom target values' },
]

export default function GrowMode({setGrowMode, currentGrowMode}) {
  return (
    <fieldset>
      <legend className="text-sm/6 font-semibold text-gray-900">Select a grow mode:</legend>
      <RadioGroup
        value={currentGrowMode}
        onChange={setGrowMode}
        className="mt-2 grid grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-4"
      >
        {growModes.map((growMode) => (
          <Radio
            key={growMode.id}
            value={growMode}
            aria-label={growMode.title}
            aria-description={`${growMode.description}`}
            className="group relative flex cursor-pointer rounded-lg border border-gray-300 bg-white p-4 shadow-sm focus:outline-none data-[focus]:border-cyan-800 data-[focus]:ring-2 data-[focus]:ring-cyan-800"
          >
            <span className="flex flex-1">
              <span className="flex flex-col">
                <span className="block text-sm font-medium text-gray-900">{growMode.title}</span>
                <span className="mt-1 flex items-center text-sm text-gray-500">{growMode.description}</span>
              </span>
            </span>
            <CheckCircleIcon
              aria-hidden="true"
              className="size-5 text-cyan-800 group-[&:not([data-checked])]:invisible"
            />
            <span
              aria-hidden="true"
              className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent group-data-[focus]:border group-data-[checked]:border-cyan-800"
            />
          </Radio>
        ))}
      </RadioGroup>
    </fieldset>
  )
}

GrowMode.propTypes = {
  setGrowMode: PropTypes.func.isRequired, // Ensures `setGrowMode` is a function and is required
};
GrowMode.propTypes = {
  currentGrowMode: PropTypes.object.isRequired, // Ensures `setGrowMode` is a function and is required
};